<ul class="breadcrumb" *ngIf="environmentSettings.PSS">
  <li>
    <a [routerLink]="['/']">Home</a>
  </li>
  <li>
    <a [routerLink]="['/tasks/library']">LibraryTasks</a>
  </li>
  <li>
    Create Task
  </li>
</ul>
<section class="card">
  <div class="card-header">
    <span class="cat__core__title">
      <strong>Create Task</strong>
    </span>

    <button type="button" class="btn btn-sm btn-primary pull-right btn-paste-task ml-2"
      [disabled]="isApplyingTaskTemplate" (click)="pasteTaskFromClipboard()" style="margin-right: 10px;">
      <i class="fa fa-paste"></i>
      <span *ngIf="!isApplyingTaskTemplate">Paste Task</span>
      <span *ngIf="isApplyingTaskTemplate">Pasting...</span>
    </button>

    <button type="button" class="btn btn-sm btn-default pull-right btn-back" (click)="ShowCompanyTasks()">
      <i class="fa fa-chevron-circle-left"></i>Back
    </button>

  </div>
  <div class="card-block">
    <div class="alert alert-info paste-task-banner" *ngIf="lastTemplateTaskName">
      Prefilled using task
      <strong>{{ lastTemplateTaskName }}</strong>. Review and update before saving.
      <button type="button" class="close" (click)="lastTemplateTaskName = null">
        &times;
      </button>
    </div>
    <div class="row">
      <div class="col-lg-12">

        <div class="margin-bottom-50">
          <form [formGroup]="taskForm" class="well">
            <div class="modal-content">

              <div class="modal-body" style="position: relative;">
                <!-- Loader overlay for add task -->
                <div class="add-task-loader-overlay" *ngIf="isSavingTask">
                  <div class="add-task-loader-container">
                    <img src="assets/images/DigiCompany_loader.png" class="add-task-spinner" alt="Loading..." />
                  </div>
                </div>
                <div class="form-block-row">
                  <div class="row">
                    <div class="col-md-4 form-block-cell">
                      <label class="form-control-label form-block-label">Global / Company</label>
                      <div class="form-group form-block-input">
                        <div class="md-radio md-radio-inline">
                          <input id="IsGlobalYes" type="radio" [formControl]="taskForm.controls['IsGlobal']"
                            style="position:absolute" name="IsGlobal" value="Global" class="form-check-input">
                          <label for="IsGlobalYes">Global</label>
                        </div>
                        <div class="md-radio md-radio-inline">
                          <input id="IsGlobalNo" type="radio" [formControl]="taskForm.controls['IsGlobal']"
                            style="position:absolute" name="IsGlobal" value="Company" class="form-check-input">
                          <label for="IsGlobalNo">Company</label>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-4 form-block-cell">
                      <label class="form-control-label form-block-label" for="l0">Trigger Type
                        <!-- <span _ngcontent-c2="" style="color: red;">*</span> -->
                      </label>
                      <div class="form-group form-block-input">
                        <div class="md-radio md-radio-inline">
                          <input id="IsPeriodic" type="radio" [formControl]="taskForm.controls['TriggerType']"
                            (click)="CheckTriggerType('Periodic')" style="position:absolute" name="TriggerType"
                            value="Periodic" class="form-check-input">
                          <label for="IsPeriodic">Periodic</label>
                        </div>
                        <div class="md-radio md-radio-inline">
                          <input id="IsEvent" type="radio" [formControl]="taskForm.controls['TriggerType']"
                            (click)="CheckTriggerType('Event')" style="position:absolute" name="TriggerType" value="Event"
                            class="form-check-input">
                          <label for="IsEvent">Event</label>
                        </div>
                        <!-- <div
                          *ngIf="taskForm.controls['TriggerType'].hasError('required') && taskForm.controls['TriggerType'].dirty"
                          class="form-control-error-custom" style="position: absolute; top: 100%; left: 0; white-space: nowrap;">
                          Please Select Either Periodic Or Event.
                        </div> -->
                      </div>
                    </div>

                    <div class="col-md-4 form-block-cell">
                      <label class="form-control-label form-block-label" for="l0">Trigger Id
                        <!-- <span _ngcontent-c2="" style="color: red;">*</span> -->
                      </label>
                      <ng-container *ngIf="IsTriggerTypeSelected('Event') || IsTriggerTypeSelected('Periodic'); else triggerIdDisabled">
                        <div class="form-group form-block-input" style="position: relative;">
                          <select [formControl]="taskForm.controls['tasktriggerId']" class="form-control select">
                            <option value="">Select</option>
                            <option *ngFor="let taskTriggerType of taskTriggerTypes" value={{taskTriggerType._id}}>
                              {{taskTriggerType.Name}}
                            </option>
                          </select>
                          <!-- <div
                            *ngIf="taskForm.controls['tasktriggerId'].hasError('required') && taskForm.controls['tasktriggerId'].dirty"
                            class="form-control-error-custom" style="position: absolute; top: 100%; left: 0; white-space: nowrap;">
                            Task Trigger type is required.
                          </div> -->
                        </div>
                      </ng-container>
                      <ng-template #triggerIdDisabled>
                        <div class="form-group form-block-input">
                          <select class="form-control select" disabled>
                            <option value="">Select Trigger Type First</option>
                          </select>
                        </div>
                      </ng-template>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-6 form-block-cell" *ngIf="checkTriggerId(taskForm.controls['tasktriggerId'].value)">
                      <label class="form-control-label form-block-label" for="l0">Specific Date</label>
                      <div class="form-group form-block-input" style="position: relative;">
                        <app-datepicker-material [formControl]="taskForm.controls['fixedDate']"
                          [(ngModel)]="fixedDateDateModel" [placeholder]="'dd-mm-yyyy'" [disabled]="false"
                          (click)="$event.stopPropagation()" style="width: 100%;">
                        </app-datepicker-material>
                      </div>
                    </div>
                    <div class="col-md-6 form-block-cell" *ngIf="isCheckerRole">
                      <label class="form-control-label form-block-label" for="consequenceType">Consequences Type
                        <span style="color: red;">*</span>
                      </label>
                      <div class="form-group form-block-input form-block-input-center">
                        <div class="radio-container consequence-type-radios">
                          <div class="md-radio md-radio-inline">
                            <input id="consequenceSystem" type="radio"
                              [checked]="consequenceMode === 'system'"
                              style="position:absolute"
                              name="consequenceType"
                              value="system"
                              (change)="setConsequenceMode('system')"
                              class="form-check-input">
                            <label for="consequenceSystem">System Defined</label>
                          </div>
                          <div class="md-radio md-radio-inline">
                            <input id="consequenceUser" type="radio"
                              [checked]="consequenceMode === 'user'"
                              style="position:absolute"
                              name="consequenceType"
                              value="user"
                              (change)="setConsequenceMode('user')"
                              class="form-check-input">
                            <label for="consequenceUser">User Defined</label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row" *ngIf="IsTriggerTypeSelected('Periodic')">
                    <div class="col-md-6 form-block-cell">
                      <label class="form-control-label form-block-label" for="l0">Trigger Starting Date</label>
                      <div class="form-group form-block-input" style="position: relative;">
                        <app-datepicker-material [formControl]="taskForm.controls['TriggerStartingDate']"
                          [(ngModel)]="TriggerStartingDateModel" [placeholder]="'dd-mm-yyyy'" [minDate]="null"
                          [maxDate]="null" [disabled]="false" (ngModelChange)="changeTrigger()"
                          (click)="$event.stopPropagation()" style="width: 100%;">
                        </app-datepicker-material>
                        <div *ngIf="(triggerType==='Periodic' && TriggerStartingDateModel===undefined)"
                          class="form-control-error-custom" style="position: absolute; top: 100%; left: 50%; transform: translateX(-50%); white-space: nowrap;">
                          Please Select Date.
                        </div>
                      </div>
                    </div>

                    <div class="col-md-6 form-block-cell">
                      <label class="form-control-label form-block-label" for="l0">End Date</label>
                      <div class="form-group form-block-input" style="position: relative;">
                        <app-datepicker-material [formControl]="taskForm.controls['endDate']"
                          [(ngModel)]="EndDateModel" [placeholder]="'dd-mm-yyyy'"
                          [minDate]="TriggerStartingDateModel" [disabled]="false"
                          (click)="$event.stopPropagation()" style="width: 100%;">
                        </app-datepicker-material>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="form-block-row">
                  <div class="row">
                    <div class="col-md-3 form-block-cell">
                      <label class="form-control-label form-block-label">Statutory / Internal</label>
                      <div class="form-group form-block-input">
                        <select class="form-control" [formControl]="taskForm.controls['policytypeId']">
                          <option value="0">Select</option>
                          <option *ngFor="let policytype of policyTypes" value={{policytype.id}}>
                            {{policytype.name}}
                          </option>
                        </select>
                      </div>
                    </div>

                    <div class="col-md-3 form-block-cell">
                      <label class="form-control-label form-block-label">Risk Profile</label>
                      <div class="form-group form-block-input">
                        <select [formControl]="taskForm.controls['risktypeId']" class="form-control select">
                          <option value="0">Select</option>
                          <option *ngFor="let riskType of riskTypes" value={{riskType.id}}>
                            {{riskType.name}}
                          </option>
                        </select>
                      </div>
                    </div>
                    <div class="col-md-3 form-block-cell">
                      <label class="form-control-label form-block-label" for="l0">Date Option
                        <!-- <span _ngcontent-c2="" style="color: red;">*</span> -->
                      </label>
                      <div class="form-group form-block-input" style="position: relative;">
                        <select [formControl]="taskForm.controls['DateOption']" class="form-control select">
                          <option value="">Select</option>
                          <option *ngFor="let dateOption of dateOptions" value={{dateOption.id}}>
                            {{dateOption.name}}
                          </option>
                        </select>
                        <!-- <div
                          *ngIf="taskForm.controls['DateOption'].hasError('required') && taskForm.controls['DateOption'].dirty"
                          class="form-control-error-custom" style="position: absolute; top: 100%; left: 0; white-space: nowrap;">
                          Please Select Date option.
                        </div> -->
                      </div>
                    </div>
                    <div class="col-md-3 form-block-cell">
                      <label class="form-control-label form-block-label">Meeting Type  </label>
                      <select [formControl]="taskForm.controls['meetingtypeId']" class="form-control select">
                        <option value="">None</option>
                        <option *ngFor="let meetingType of meetingTypes" value={{meetingType._id}}>
                          {{meetingType.MeetingType}}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>

                <div class="form-block-row">
                  <div class="row">
                    <div class="col-md-6 form-block-cell">
                      <label class="form-control-label form-block-label" for="l0">Task
                        <span _ngcontent-c2="" style="color: red;">*</span>
                      </label>
                      <div class="form-group form-block-input" style="position: relative;">
                        <input id="taskName" [formControl]="taskForm.controls['TaskName']" class="form-control" appAutoInappropriateLanguageValidator>
                        <div
                          *ngIf="(taskForm.controls['TaskName'].hasError('required') || taskForm.controls['TaskName'].hasError('whitespace')) && taskForm.controls['TaskName'].dirty"
                          class="form-control-error-custom" style="position: absolute; top: 100%; left: 0; white-space: nowrap;">
                          The task name is required.
                        </div>
                        <div 
                        *ngIf="taskForm.get('TaskName')?.errors?.['inappropriateLanguage'] && taskForm.get('TaskName')?.touched"
                        class="form-control-error-custom" style="color: red; position: absolute; top: 100%; left: 0; white-space: nowrap;">
                        {{ taskForm.get('TaskName')?.errors?.['inappropriateLanguage']?.message }}
                      </div>
                      </div>
                    </div>

                    <div class="col-md-6 form-block-cell">
                      <label class="form-control-label form-block-label" for="l0">Tag
                        <!-- <span _ngcontent-c2="" style="color: red;">*</span> -->
                      </label>
                      <div class="form-group form-block-input" style="position: relative;">
                        <div class="input-group">
                          <select [formControl]="taskForm.controls['groupId']" class="form-control select">
                            <option value="">Select</option>
                            <option *ngFor="let group of groupTypes" value={{group._id}}>
                              {{group.GroupName}}
                            </option>
                          </select>
                          <div class="input-group-append" style="margin-left: 8px;">
                            <button type="button" class="btn btn-primary" data-toggle="modal" data-target="#groupDialog">
                              <i class="fa fa-plus"></i>Add
                            </button>
                          </div>
                        </div>
                        <!-- <div
                          *ngIf="taskForm.controls['groupId'].hasError('required') && taskForm.controls['groupId'].dirty"
                          class="form-control-error-custom" style="position: absolute; top: 100%; left: 0; white-space: nowrap;">
                          Tag is required.
                        </div> -->
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-6 form-block-cell">
                      <label class="form-control-label form-block-label" for="l0">Task Description
                        <!-- <span _ngcontent-c2="" style="color: red;">*</span> -->
                      </label>
                      <div class="form-group form-block-input" style="position: relative;">
                        <textarea [formControl]="taskForm.controls['TaskDescription']" class="form-control"
                          rows="3" appAutoInappropriateLanguageValidator></textarea>
                        <!-- <div
                          *ngIf="(taskForm.controls['TaskDescription'].hasError('required') || taskForm.controls['TaskDescription'].hasError('whitespace')) && taskForm.controls['TaskDescription'].dirty"
                          class="form-control-error-custom" style="position: absolute; top: 100%; left: 0; white-space: nowrap;">
                          Task description is required.
                        </div> -->
                        <div 
                          *ngIf="taskForm.get('TaskDescription')?.errors?.['inappropriateLanguage'] && taskForm.get('TaskDescription')?.touched"
                          class="form-control-error-custom" style="color: red; position: absolute; top: 100%; left: 0; white-space: nowrap;">
                          {{ taskForm.get('TaskDescription')?.errors?.['inappropriateLanguage']?.message }}
                        </div>
                      </div>
                    </div>

                    <div class="col-md-6 form-block-cell">
                      <label class="form-control-label form-block-label" for="l0">Email Contents</label>
                      <div class="form-group form-block-input">
                        <textarea [formControl]="taskForm.controls['EmailContents']" class="form-control"
                          rows="3">
                        </textarea>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="form-block-row">
                  <div class="row">
                    <div class="col-md-6 form-block-cell">
                      <label class="form-control-label form-block-label" for="l0">Assigned To</label>
                      <div class="form-group form-block-input">
                        <ng-select [items]="assignedusers" [multiple]="true" bindLabel="label" bindValue="value"
                          placeholder="Select User" [formControl]="taskForm.controls['AssignedTo']"
                          (change)="onSelectMemberDisableFromOther(true)" class="form-control m-b-10 p-8"
                          style="padding: 0px; text-align:left;">
                        </ng-select>
                      </div>
                    </div>

                    <div class="col-md-6 form-block-cell">
                      <label class="form-control-label form-block-label" for="l0">Colleague</label>
                      <div class="form-group form-block-input">
                        <ng-select [items]="collegues" [multiple]="true" bindLabel="label" bindValue="value"
                          placeholder="Select collegue" [formControl]="taskForm.controls['Collegues']"
                          (change)="onSelectMemberDisableFromOther()" class="form-control m-b-10 p-8"
                          style="padding: 0px; text-align:left;">
                        </ng-select>
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-4 form-block-cell">
                      <label class="form-control-label form-block-label" for="l0">Due Date</label>
                      <div class="form-group form-block-input" style="position: relative;">
                        <app-datepicker-material [formControl]="taskForm.controls['CompletionDate']"
                         [placeholder]="'dd-mm-yyyy'" [disabled]="false">
                        </app-datepicker-material>
                        <div
                          *ngIf="taskForm.controls['CompletionDays'].hasError('max') && taskForm.controls['CompletionDays'].dirty"
                          class="form-control-error-custom" style="position: absolute; top: 100%; left: 0; white-space: nowrap;">
                          Please enter a maximum 9999 days.
                        </div>
                        <div
                          *ngIf="taskForm.controls['CompletionDays'].hasError('min') && taskForm.controls['CompletionDays'].dirty"
                          class="form-control-error-custom" style="position: absolute; top: 100%; left: 0; white-space: nowrap;">
                          Please enter a minimum -9999 days.
                        </div>
                      </div>
                    </div>

                    <div class="col-md-4 form-block-cell">
                      <label class="form-control-label form-block-label" for="l0">Reminder Start Date</label>
                      <div class="form-group form-block-input" style="position: relative;">
                        <app-datepicker-material [formControl]="taskForm.controls['ReminderDate']"
                          [placeholder]="'dd-mm-yyyy'" [(ngModel)]="ReminderDateModel" [disabled]="false" [minDate]="null" [maxDate]="EndDateModel" (click)="$event.stopPropagation()">
                        </app-datepicker-material>
                        <div
                          *ngIf="taskForm.controls['ReminderDate'].hasError('reminderBeforeBase') && taskForm.controls['ReminderDate'].touched"
                          class="form-control-error-custom" style="position: absolute; top: 100%; left: 0; white-space: nowrap;">
                          Reminder start date cannot be earlier than the trigger start date or fixed date.
                        </div>
                      </div>
                    </div>

                    <div class="col-md-4 form-block-cell">
                      <label class="form-control-label form-block-label" for="l0">Reminder Frequency (days)</label>
                      <div class="form-group form-block-input" style="position: relative;">
                        <input [formControl]="taskForm.controls['ReminderFrequency']" class="form-control"
                          [OnlyNumber]=true (input)="checkRemindersValidation()">
                        <div
                          *ngIf="taskForm.controls['ReminderFrequency'].hasError('max') && taskForm.controls['ReminderFrequency'].dirty"
                          class="form-control-error-custom" style="position: absolute; top: 100%; left: 0; white-space: nowrap;">
                          Please enter a maximum 30 days.
                        </div>
                        <div
                          *ngIf="taskForm.controls['ReminderFrequency'].hasError('min') && taskForm.controls['ReminderFrequency'].dirty"
                          class="form-control-error-custom" style="position: absolute; top: 100%; left: 0; white-space: nowrap;">
                          Reminder Frequency (days) cannot be negative.
                        </div>
                        <div id="ErrorreminderFrequency" *ngIf="reminderFrequencyError.isError"
                          style="color: #fb434a;font-size: 80%;z-index: 1; position: absolute; top: 100%; left: 0; white-space: nowrap;">
                          {{ reminderFrequencyError.errorMessage }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="form-block-row">
                  <div class="row">
                    <div class="col-md-4 form-block-cell">
                      <label class="form-control-label form-block-label" for="l0">Responsible User</label>
                      <div class="form-group form-block-input">
                        <ng-select [items]="responsibleUsers" [multiple]="true" bindLabel="label"
                          bindValue="value" placeholder="Select"
                          [formControl]="taskForm.controls['ResponsibleUser']"
                          (change)="onResponsibleUserChange($event)" class="form-control m-b-10 p-8"
                          style="padding: 0px; text-align:left;">
                        </ng-select>
                      </div>
                    </div>

                    <div class="col-md-4 form-block-cell">
                      <label class="form-control-label form-block-label" for="l0">Responsible User 1st Escalation</label>
                      <div class="form-group form-block-input">
                        <ng-select [items]="escalation1ofResponsibleUsers" [multiple]="true" bindLabel="label"
                          bindValue="value" placeholder="Select"
                          [formControl]="taskForm.controls['Escalation1ofResponsibleUser']"
                          (change)="onEscalation1ofResponsibleUserChange($event)"
                          class="form-control m-b-10 p-8" style="padding: 0px; text-align:left;">
                        </ng-select>
                      </div>
                    </div>

                    <div class="col-md-4 form-block-cell">
                      <label class="form-control-label form-block-label" for="l0">Responsible User 2nd Escalation</label>
                      <div class="form-group form-block-input">
                        <ng-select [items]="escalation2ofResponsibleUsers" [multiple]="true" bindLabel="label"
                          bindValue="value" placeholder="Select"
                          [formControl]="taskForm.controls['Escalation2ofResponsibleUser']"
                          (change)="onEscalation2ofResponsibleUserChange($event)"
                          class="form-control m-b-10 p-8" style="padding: 0px; text-align:left;">
                        </ng-select>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="form-block-row escalation-block">
                  <div class="escalation-header" (click)="isEscalationExpanded = !isEscalationExpanded" style="cursor: pointer; padding: 10px 20px; display: flex; justify-content: space-between; align-items: center; border-bottom: 1px solid #e9ecef;">
                    <h5 style="margin: 0; font-weight: 500; color: #333;">Escalation</h5>
                    <i class="fa" [ngClass]="{'fa-chevron-down': !isEscalationExpanded, 'fa-chevron-up': isEscalationExpanded}" style="color: #666;"></i>
                  </div>
                  <div *ngIf="isEscalationExpanded" style="padding: 15px 20px;">
                    <div class="row">
                      <div class="col-md-4 form-block-cell">
                        <label class="form-control-label form-block-label" for="l0">1st Escalation</label>
                        <div class="form-group form-block-input">
                          <ng-select [items]="escalation1Users" [multiple]="true" bindLabel="label"
                            bindValue="value" placeholder="Select"
                            [formControl]="taskForm.controls['Escalation1ofAssignedTo']"
                            (change)="onSelectMemberDisableFromOther()" class="form-control m-b-10 p-8"
                            style="padding: 0px; text-align:left;">
                          </ng-select>
                        </div>
                      </div>

                      <div class="col-md-4 form-block-cell">
                        <label class="form-control-label form-block-label" for="l0">1st Escalation Start</label>
                        <div class="form-group form-block-input" style="position: relative;">
                          <input [formControl]="taskForm.controls['EscalationDays']" class="form-control"
                            [OnlyNumber]=true (input)="checkRemindersValidation()">
                          <div
                            *ngIf="taskForm.controls['EscalationDays'].hasError('max') && taskForm.controls['EscalationDays'].dirty"
                            class="form-control-error-custom" style="position: absolute; top: 100%; left: 0; white-space: nowrap;">
                            Please enter a maximum 30 days.
                          </div>
                          <div
                            *ngIf="taskForm.controls['EscalationDays'].hasError('min') && taskForm.controls['EscalationDays'].dirty"
                            class="form-control-error-custom" style="position: absolute; top: 100%; left: 0; white-space: nowrap;">
                            1st Escalation Start cannot be negative.
                          </div>
                          <div id="ErrorfirstEscalationStart" *ngIf="firstEscalationStartError.isError"
                            style="color: #fb434a;font-size: 80%;z-index: 1; position: absolute; top: 100%; left: 0; white-space: nowrap;">
                            {{ firstEscalationStartError.errorMessage }}
                          </div>
                        </div>
                      </div>

                      <div class="col-md-4 form-block-cell">
                        <label class="form-control-label form-block-label" for="l0">1st Escalation reminder frequency</label>
                        <div class="form-group form-block-input" style="position: relative;">
                          <input [formControl]="taskForm.controls['ReminderFrequencyLevel1']"
                            class="form-control" [OnlyNumber]=true (input)="checkRemindersValidation()">
                          <div
                            *ngIf="taskForm.controls['ReminderFrequencyLevel1'].hasError('max') && taskForm.controls['ReminderFrequencyLevel1'].dirty"
                            class="form-control-error-custom" style="position: absolute; top: 100%; left: 0; white-space: nowrap;">
                            Please enter a maximum 30 days.
                          </div>
                          <div
                            *ngIf="taskForm.controls['ReminderFrequencyLevel1'].hasError('min') && taskForm.controls['ReminderFrequencyLevel1'].dirty"
                            class="form-control-error-custom" style="position: absolute; top: 100%; left: 0; white-space: nowrap;">
                            1st Escalation reminder frequency cannot be negative.
                          </div>
                          <div id="ErrorfirstEscalationreminderFrequency"
                            *ngIf="firstEscalationreminderFrequencyError.isError"
                            style="color: #fb434a;font-size: 80%;z-index: 1; position: absolute; top: 100%; left: 0; white-space: nowrap;">
                            {{ firstEscalationreminderFrequencyError.errorMessage }}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row" style="margin-top: 15px;">
                      <div class="col-md-4 form-block-cell">
                        <label class="form-control-label form-block-label" for="l0">2nd Escalation</label>
                        <div class="form-group form-block-input">
                          <ng-select [items]="escalation2Users" [multiple]="true" bindLabel="label"
                            bindValue="value" placeholder="Select"
                            [formControl]="taskForm.controls['Escalation2ofAssignedTo']"
                            (change)="onSelectMemberDisableFromOther()" class="form-control m-b-10 p-8"
                            style="padding: 0px; text-align:left;">
                          </ng-select>
                        </div>
                      </div>

                      <div class="col-md-4 form-block-cell">
                        <label class="form-control-label form-block-label" for="l0">2nd Escalation Start</label>
                        <div class="form-group form-block-input" style="position: relative;">
                          <input [formControl]="taskForm.controls['Level2EscalationDays']"
                            class="form-control" [OnlyNumber]=true (input)="checkRemindersValidation()">
                          <div
                            *ngIf="taskForm.controls['Level2EscalationDays'].hasError('max') && taskForm.controls['Level2EscalationDays'].dirty"
                            class="form-control-error-custom" style="position: absolute; top: 100%; left: 0; white-space: nowrap;">
                            Please enter a maximum 30 days.
                          </div>
                          <div
                            *ngIf="taskForm.controls['Level2EscalationDays'].hasError('min') && taskForm.controls['Level2EscalationDays'].dirty"
                            class="form-control-error-custom" style="position: absolute; top: 100%; left: 0; white-space: nowrap;">
                            2nd Escalation Start cannot be negative.
                          </div>
                          <div id="ErrorsecondEscalationStart" *ngIf="secondEscalationStartError.isError"
                            style="color: #fb434a;font-size: 80%;z-index: 1; position: absolute; top: 100%; left: 0; white-space: nowrap;">
                            {{ secondEscalationStartError.errorMessage }}
                          </div>
                        </div>
                      </div>

                      <div class="col-md-4 form-block-cell">
                        <label class="form-control-label form-block-label" for="l0">2nd Escalation reminder frequency</label>
                        <div class="form-group form-block-input" style="position: relative;">
                          <input [formControl]="taskForm.controls['ReminderFrequencyLevel2']"
                            class="form-control" [OnlyNumber]=true (input)="checkRemindersValidation()">
                          <div
                            *ngIf="taskForm.controls['ReminderFrequencyLevel2'].hasError('max') && taskForm.controls['ReminderFrequencyLevel2'].dirty"
                            class="form-control-error-custom" style="position: absolute; top: 100%; left: 0; white-space: nowrap;">
                            Please enter a maximum 30 days.
                          </div>
                          <div
                            *ngIf="taskForm.controls['ReminderFrequencyLevel2'].hasError('min') && taskForm.controls['ReminderFrequencyLevel2'].dirty"
                            class="form-control-error-custom" style="position: absolute; top: 100%; left: 0; white-space: nowrap;">
                            2nd Escalation reminder frequency cannot be negative.
                          </div>
                          <div id="ErrorsecondEscalationreminderFrequency"
                            *ngIf="secondEscalationreminderFrequencyError.isError"
                            style="color: #fb434a;font-size: 80%;z-index: 1; position: absolute; top: 100%; left: 0; white-space: nowrap;">
                            {{ secondEscalationreminderFrequencyError.errorMessage }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

               

                <div class="row">
                 
                <div class="form-block-row">
                  
                  <div class="row">
                    <div class="col-md-6 form-block-cell">
                      <label class="form-control-label form-block-label" for="l0">System Defined Consequences</label>
                      <div class="form-group form-block-input">
                        <textarea [formControl]="taskForm.controls['PreConsequences']" class="form-control"
                          rows="3">
                        </textarea>
                      </div>
                    </div>

                    <div class="col-md-6 form-block-cell">
                      <label class="form-control-label form-block-label" for="l0">User Defined Consequences</label>
                      <div class="form-group form-block-input">
                        <textarea [formControl]="taskForm.controls['UserConsequences']" class="form-control" rows="3">
                        </textarea>
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-6 form-block-cell">
                      <label class="form-control-label form-block-label">Upload File</label>
                      <div class="form-group form-block-input">
                        <input type="file" class='form-control fileUpload' #attachments type="file"
                          (change)="onFileChanged($event)" accept=".xlsx, .xls, .doc, .docx, .pdf" />
                      </div>
                    </div>

                    <div class="col-md-6 form-block-cell">
                      <label class="form-control-label form-block-label" for="l0">Emails
                        <!-- <span _ngcontent-c2="" style="color: red;">*</span> -->
                      </label>
                      <div class="form-group form-block-input">
                        <label class="switch">
                          <input type="checkbox" 
                            [formControl]="taskForm.controls['Email']" >
                          <span class="slider round"></span>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
                 
                  <!-- <div class="col-md-6">
                    &nbsp;
                  </div> -->

                  <!-- <div class="col-md-12" *ngIf="IsTriggerTypeSelected('Event') || IsTriggerTypeSelected('Periodic')">
                    <div class="row">
                      <div class="col-md-6">
                        <div class="row">
                          <div class="col-md-4">
                            <label class="form-control-label" for="l0">Trigger Id
                              <span _ngcontent-c2="" style="color: red;">*</span>
                            </label>
                          </div>
                          <div class="col-md-8">
                            <div class="form-group">
                              <select [formControl]="taskForm.controls['tasktriggerId']" class="form-control select">
                                <option value="">Select</option>
                                <option *ngFor="let taskTriggerType of taskTriggerTypes" value={{taskTriggerType._id}}>
                                  {{taskTriggerType.Name}}
                                </option>
                              </select>
                              <div
                                *ngIf="taskForm.controls['tasktriggerId'].hasError('required') && taskForm.controls['tasktriggerId'].dirty"
                                class="form-control-error-custom">
                                Task Trigger type is required.
                              </div>
                            </div>
                          </div>
                        </div>
                      </div> -->
 <!-- </div>

                  </div> -->

                   

                  <!-- <div class="col-md-12" *ngIf="checkTriggerId(taskForm.controls['tasktriggerId'].value)">
                    <div class="row">
                      <div class="col-md-6">
                        <div class="row">
                          <div class="col-md-4">
                            <label class="form-control-label" for="l0">Specific Date</label>
                          </div>
                          <div class="col-md-8">
                            <div class="form-group">
                              <div class="input-group" (click)="$event.stopPropagation()">
                                <app-datepicker-material [formControl]="taskForm.controls['fixedDate']"
                                  [(ngModel)]="fixedDateDateModel" [placeholder]="'dd-mm-yyyy'" [disabled]="false">
                                </app-datepicker-material>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div> -->
                  <!-- <div class="col-md-2">
                    <label class="form-control-label" for="l0">Due Date </label>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group">
                      <app-datepicker-material [formControl]="taskForm.controls['CompletionDate']"
                       [placeholder]="'dd-mm-yyyy'" [disabled]="false">
                      </app-datepicker-material>
                      <div
                        *ngIf="taskForm.controls['CompletionDays'].hasError('max') && taskForm.controls['CompletionDays'].dirty"
                        class="form-control-error-custom">
                        Please enter a maximum 9999 days.
                      </div>
                      <div
                        *ngIf="taskForm.controls['CompletionDays'].hasError('min') && taskForm.controls['CompletionDays'].dirty"
                        class="form-control-error-custom">
                        Please enter a minimum -9999 days.
                      </div>
                    </div>

                  </div> -->


                <!-- <div class="form-block-row"> -->
                  <!-- <div class="row">
                    <div class="col-md-12 form-block-cell">
                      <label class="form-control-label form-block-label" for="l0">1st Escalation</label>
                      <div class="form-group form-block-input">
                        <ng-select [items]="escalation1Users" [multiple]="true" bindLabel="label"
                          bindValue="value" placeholder="Select"
                          [formControl]="taskForm.controls['Escalation1ofAssignedTo']"
                          (change)="onSelectMemberDisableFromOther()" class="form-control m-b-10 p-8"
                          style="padding: 0px; text-align:left;">
                        </ng-select>
                      </div>
                    </div>
                  </div> -->

                  <!-- <div class="row"> -->
                    <!-- <div class="col-md-6 form-block-cell">
                      <label class="form-control-label form-block-label" for="l0">1st Escalation Start</label>
                      <div class="form-group form-block-input" style="position: relative;">
                        <input [formControl]="taskForm.controls['EscalationDays']" class="form-control"
                          [OnlyNumber]=true (input)="checkRemindersValidation()">
                        <div
                          *ngIf="taskForm.controls['EscalationDays'].hasError('max') && taskForm.controls['EscalationDays'].dirty"
                          class="form-control-error-custom" style="position: absolute; top: 100%; left: 0; white-space: nowrap;">
                          Please enter a maximum 30 days.
                        </div>
                        <div
                          *ngIf="taskForm.controls['EscalationDays'].hasError('min') && taskForm.controls['EscalationDays'].dirty"
                          class="form-control-error-custom" style="position: absolute; top: 100%; left: 0; white-space: nowrap;">
                          1st Escalation Start cannot be negative.
                        </div>
                        <div id="ErrorfirstEscalationStart" *ngIf="firstEscalationStartError.isError"
                          style="color: #fb434a;font-size: 80%;z-index: 1; position: absolute; top: 100%; left: 0; white-space: nowrap;">
                          {{ firstEscalationStartError.errorMessage }}
                        </div>
                      </div>
                    </div> -->

                    <!-- <div class="col-md-6 form-block-cell">
                      <label class="form-control-label form-block-label" for="l0">1st Escalation reminder frequency</label>
                      <div class="form-group form-block-input" style="position: relative;">
                        <input [formControl]="taskForm.controls['ReminderFrequencyLevel1']"
                          class="form-control" [OnlyNumber]=true (input)="checkRemindersValidation()">
                        <div
                          *ngIf="taskForm.controls['ReminderFrequencyLevel1'].hasError('max') && taskForm.controls['ReminderFrequencyLevel1'].dirty"
                          class="form-control-error-custom" style="position: absolute; top: 100%; left: 0; white-space: nowrap;">
                          Please enter a maximum 30 days.
                        </div>
                        <div
                          *ngIf="taskForm.controls['ReminderFrequencyLevel1'].hasError('min') && taskForm.controls['ReminderFrequencyLevel1'].dirty"
                          class="form-control-error-custom" style="position: absolute; top: 100%; left: 0; white-space: nowrap;">
                          1st Escalation reminder frequency cannot be negative.
                        </div>
                        <div id="ErrorfirstEscalationreminderFrequency"
                          *ngIf="firstEscalationreminderFrequencyError.isError"
                          style="color: #fb434a;font-size: 80%;z-index: 1; position: absolute; top: 100%; left: 0; white-space: nowrap;">
                          {{ firstEscalationreminderFrequencyError.errorMessage }}
                        </div>
                      </div>
                    </div> -->
                  <!-- </div>
                </div> -->
                
                  

                  
               
                 
               
                </div>
              </div>
              <div class="modal-footer">
                <button id="btnsaveTask" type="button" class="btn btn-sm btn-primary"
                  [disabled]="!taskForm.valid || disabledOnclick" (click)="addTask('add')"><i
                    class="fa fa-save"></i>Save to
                  Library</button>
                <button id="btnshowtaskparticulars" type="button" data-toggle="modal" class="btn btn-sm btn-primary"
                  (click)="addAndActicateCheck('addAndActivate')" [disabled]="!taskForm.valid || disabledOnclick"><i
                    class="fa fa-save"></i>Save & Activate</button>
                <button id="btnshowaddProcessTask" type="button" data-toggle="modal"
                  data-target="#addtasktoprocessDialog" class="btn btn-sm btn-primary"
                  [disabled]='!taskForm.valid || triggerType==="Periodic" || disabledOnclick'><i
                    class="fa fa-save"></i>Add to Process</button>
                <button type="button" class="btn btn-sm" data-dismiss="modal" (click)="reset()"> <i
                    class="fa fa-refresh"></i>Clear</button>
              </div>
            </div>
          </form>

        </div>
      </div>
    </div>
  </div>


  <div class="modal fade" id="resetConfirmation" tabindex="-1" role="dialog" aria-labelledby="" aria-hidden="true"
    style="top: 50px;">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="myModalLabelForDelete"><i class="fa fa-question-circle-o mr-2"></i>Confirm</h5>
          <button aria-label="Close" class="close" data-dismiss="modal" type="button">
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-sm-12">
              Are you sure you want to reset the form data?
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-sm btn-danger" (click)="resetFormData()"><i
              class="fa fa-check"></i>Yes</button>
          <button type="button" class="btn btn-sm" data-dismiss="modal"><i class="fa fa-times"></i>No</button>
        </div>
      </div>
    </div>
  </div>


  <div class="modal fade modal-size-medium" id="taskParticularsDialog" tabindex="-1" role="dialog" aria-labelledby=""
    aria-hidden="true">
    <div class="modal-dialog">
      <form [formGroup]="taskForm" class="well">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="myModalLabel">Task Particulars</h5>
            <button aria-label="Close" class="close" data-dismiss="modal" type="button"
              (click)="removeTaskParticularsvalidation()">
              <i class="fa fa-times"></i>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-3">
                <label class="form-control-label" for="l0">Task Particulars
                  <span _ngcontent-c2="" style="color: red;">*</span>
                </label>
              </div>
              <div class="col-md-9">
                <div class="form-group">

                  <input [formControl]="taskForm.controls['TaskParticulars']" class="form-control"
                    [(ngModel)]="taskParticularsmodel">
                  <div
                    *ngIf="taskForm.controls['TaskParticulars'].hasError('required') && (taskForm.controls['TaskParticulars'].dirty)"
                    class="form-control-error-custom">
                    Task Particulars Name is required.
                  </div>
                  <!-- <div *ngIf="(taskParticularsmodel=== undefined)" class="form-control-error-custom">
                      Task Particulars Name is required.
                   </div>  -->
                  <!-- <div *ngIf="taskForm.controls['TaskParticulars'].hasError('pattern') && taskForm.controls['TaskParticulars'].touched" class="form-control-error-custom">
                     Please enter  valid Task Particulars Name.
                  </div> -->
                </div>
              </div>

            </div>

          </div>
          <div class="modal-footer">

            <button id="btnsaveandActivateTask" type="button" class="btn btn-sm btn-primary"
              [disabled]='!taskForm.valid || (taskParticularsmodel=== undefined) || disabledOnclick'
              (click)="addTaskandActivate()"><i class="fa fa-save"></i>Save and Activate</button>

            <button type="button" class="btn btn-sm" data-dismiss="modal" (click)="removeTaskParticularsvalidation()">
              <i class="fa fa-times"></i>Close</button>
          </div>
        </div>
      </form>
    </div>
  </div>

  <div class="modal fade modal-size-medium" id="addtasktoprocessDialog" tabindex="-1" role="dialog" aria-labelledby=""
    aria-hidden="true">
    <div class="modal-dialog">
      <form [formGroup]="taskForm" class="well">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="myModalLabel">Process</h5>
            <button aria-label="Close" class="close" data-dismiss="modal" type="button"
              (click)="removeProcessvalidation()">
              <i class="fa fa-times"></i>
            </button>
          </div>
          <div class="modal-body">

            <div class="row">

              <div class="col-md-6">
                <label class="form-control-label" for="l0"> Consequences Type
                </label>
              </div>
              <div class="col-md-6">
                <div class="form-group">

                  <div class="md-radio md-radio-inline">
                    <input id="IsPreDefined" type="radio" [formControl]="taskForm.controls['IsPredefinedorUserdefined']"
                      style="position:absolute" name="IsPredefinedorUserdefined" value="Predefined"
                      (change)="setConsequenceMode('system')" class="form-check-input">
                    <label for="IsPreDefined">System Defined</label>
                  </div>
                  <div class="md-radio md-radio-inline">
                    <input id="IsUserDefined" type="radio"
                      [formControl]="taskForm.controls['IsPredefinedorUserdefined']" style="position:absolute"
                      name="IsPredefinedorUserdefined" value="Userdefined" (change)="setConsequenceMode('user')"
                      class="form-check-input">
                    <label for="IsUserDefined">User Defined</label>
                  </div>

                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <label class="form-control-label" for="l0">Select Process
                  <span _ngcontent-c2="" style="color: red;">*</span>
                </label>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <select [formControl]="taskForm.controls['ProcessID']" class="form-control select"
                    [(ngModel)]="ProcessIdModel">
                    <option value=""> Select </option>
                    <option *ngFor="let process of processes" value={{process._id}}>
                      {{process.ProcessName}}
                    </option>
                  </select>
                  <div
                    *ngIf="taskForm.controls['ProcessID'].hasError('required') && (taskForm.controls['ProcessID'].dirty || taskForm.controls['ProcessID'].pristine)"
                    class="form-control-error-custom">
                    Process is required.
                  </div>
                </div>
              </div>
            </div>


          </div>
          <div class="modal-footer">

            <button id="btnsaveTasktoProcess" type="button" class="btn btn-sm btn-primary"
              [disabled]='!taskForm.valid || (ProcessIdModel === undefined || ProcessIdModel=== "") || disabledOnclick'
              (click)="addTasktoProcess()"><i class="fa fa-save"></i>Save </button>

            <button type="button" class="btn btn-sm" data-dismiss="modal" (click)="removeProcessvalidation()"> <i
                class="fa fa-times"></i>Close</button>
          </div>
        </div>
      </form>
    </div>
  </div>

</section>
<app-addgroup (groupCreated)='getGroupId($event)'></app-addgroup>
<app-alert></app-alert>